module.exports = __webpack_public_path__ + "img/p_sz_4.85486ae2.png";